var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupPeople = function SvgGroupPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 70,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 32.5,
    fill: "#fff",
    stroke: "#a2bc3a",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d490f",
    fillRule: "evenodd",
    d: "M35.5 19a5.79 5.79 0 1 0 0 11.57 5.79 5.79 0 0 0 0-11.57Zm0 1.65a4.13 4.13 0 1 1 0 8.27 4.13 4.13 0 0 1 0-8.27ZM23.94 25.6a4.13 4.13 0 1 0 0 8.27 4.13 4.13 0 0 0 0-8.26Zm0 1.66a2.48 2.48 0 1 1 0 4.96 2.48 2.48 0 0 1 0-4.96Zm23.13-1.66a4.13 4.13 0 1 0 0 8.27 4.13 4.13 0 0 0 0-8.26Zm0 1.66a2.48 2.48 0 1 1 0 4.96 2.48 2.48 0 0 1 0-4.96Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d490f",
    fillRule: "evenodd",
    d: "M27.74 36.57a7.43 7.43 0 0 0-11.24 6.39v4.95a2.48 2.48 0 0 0 2.48 2.48h33.04c1.37 0 2.48-1.1 2.48-2.48v-4.95a7.43 7.43 0 0 0-11.24-6.39 9.08 9.08 0 0 0-15.52 0Zm-.73 1.49a5.78 5.78 0 0 0-8.86 4.9v4.95c0 .46.37.83.83.83h7.58a2.3 2.3 0 0 1-.15-.83v-6.6c0-1.15.21-2.24.6-3.25Zm8.49-4.19a7.43 7.43 0 0 0-7.43 7.43v6.61a.82.82 0 0 0 .82.83h13.22a.83.83 0 0 0 .82-.83v-6.6a7.43 7.43 0 0 0-7.43-7.44Zm8.95 14.87h7.57c.46 0 .83-.37.83-.83v-4.95a5.78 5.78 0 0 0-8.86-4.9c.39 1 .6 2.1.6 3.24v6.61c0 .29-.05.57-.14.83Z",
    clipRule: "evenodd"
  })));
};
export default SvgGroupPeople;